import {Constants} from "@/constant/Constants";
import {SelectData} from "@/data/SelectData";
import { LanguageType } from '@/types';

export class Language extends SelectData{

    constructor(data: LanguageType) {
        super();
        this._name = data[Constants.NAME];
        this._id = data[Constants.ID];
    }

}